import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { fontSizes, lineHeights } from "@dana/MobiusOverrides/styles/typography";
import { onePageCheckoutShippingSectionStyles } from "@dana/Overrides/Widgets/OnePageCheckout/OnePageCheckoutShippingSection";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

onePageCheckoutShippingSectionStyles.container = mergeToNew(onePageCheckoutShippingSectionStyles.container, {
    gap: 0,
    css: css`
        background: ${themeBackgrounds.white};

        .checkout-address-container {
            display: flex;
            width: 100%;
            gap: 20px;
            padding: 16px;
        }

        .checkout-address-wrapper {
            flex-basis: 50%;
            max-width: 50%;
        }

        @media only screen and (max-width: 992px) {
            .checkout-address-container {
                display: flex;
                flex-direction: column;
            }

            .checkout-address-wrapper {
                flex-basis: 100%;
                max-width: 100%;
            }
        }
    `,
});

onePageCheckoutShippingSectionStyles.titleGridItem = mergeToNew(onePageCheckoutShippingSectionStyles.titleGridItem, {
    width: 12,
    css: css`
        background: ${themeBackgrounds.lightGray};
        padding: 16px;
    `,
});

onePageCheckoutShippingSectionStyles.titleText = mergeToNew(onePageCheckoutShippingSectionStyles.titleText, {
    transform: "capitalize",
    size: fontSizes.medium,
    lineHeight: lineHeights.medium,
    css: css`
        margin-bottom: 0;
        letter-spacing: normal;
    `,
});

onePageCheckoutShippingSectionStyles.headingGridItem = mergeToNew(
    onePageCheckoutShippingSectionStyles.headingGridItem,
    {
        css: css`
            background: ${themeBackgrounds.lightGray};
            padding: 16px;
        `,
    },
);

onePageCheckoutShippingSectionStyles.shipToGridItem = mergeToNew(onePageCheckoutShippingSectionStyles.shipToGridItem, {
    css: css`
        padding: 16px;
    `,
});

onePageCheckoutShippingSectionStyles.billToGridItem = mergeToNew(onePageCheckoutShippingSectionStyles.billToGridItem, {
    css: css`
        padding: 16px;
    `,
});

onePageCheckoutShippingSectionStyles.shippingAddressForm = mergeToNew(
    onePageCheckoutShippingSectionStyles.shippingAddressForm,
    {
        formFields: {
            container: {
                gap: 20,
            },
        },
    },
);

onePageCheckoutShippingSectionStyles.billingAddressForm = mergeToNew(
    onePageCheckoutShippingSectionStyles.billingAddressForm,
    {
        formFields: {
            container: {
                gap: 20,
            },
        },
    },
);

onePageCheckoutShippingSectionStyles.useShippingAddressGridItem = mergeToNew(
    onePageCheckoutShippingSectionStyles.useShippingAddressGridItem,
    {
        css: css`
            padding: 0 16px;
        `,
    },
);

onePageCheckoutShippingSectionStyles.saveButtonGridItem = mergeToNew(
    onePageCheckoutShippingSectionStyles.saveButtonGridItem,
    {
        css: css`
            padding: 16px;
        `,
    },
);

onePageCheckoutShippingSectionStyles.shipToSelectorModal = mergeToNew(
    onePageCheckoutShippingSectionStyles.shipToSelectorModal,
    {
        modal: {
            size: 800,
            sizeVariant: "large",
        },
        shipToSelector: {
            customerSelectorToolbar: {
                searchButton: {
                    css: css`
                        margin-left: 16px;
                        margin-right: auto;
                    `,
                },
            },
        },
        addCustomerAddressForm: {
            formFields: {
                container: {
                    gap: 20,
                },
            },
        },
        editCustomerAddressForm: {
            formFields: {
                container: {
                    gap: 20,
                },
            },
        },
    },
);

onePageCheckoutShippingSectionStyles.billToSelectorModal = mergeToNew(
    onePageCheckoutShippingSectionStyles.billToSelectorModal,
    {
        modal: {
            size: 800,
            sizeVariant: "large",
        },
        addCustomerAddressForm: {
            formFields: {
                container: {
                    gap: 20,
                },
            },
        },
        editCustomerAddressForm: {
            formFields: {
                container: {
                    gap: 20,
                },
            },
        },
    },
);

onePageCheckoutShippingSectionStyles.createNewAddressModal = mergeToNew(
    onePageCheckoutShippingSectionStyles.createNewAddressModal,
    {
        size: 800,
        sizeVariant: "large",
    },
);

onePageCheckoutShippingSectionStyles.addCustomerAddressForm = mergeToNew(
    onePageCheckoutShippingSectionStyles.addCustomerAddressForm,
    {
        formFields: {
            container: {
                gap: 20,
            },
        },
    },
);

onePageCheckoutShippingSectionStyles.linksWrapper = mergeToNew(
    onePageCheckoutShippingSectionStyles.linksWrapper, {
        css: css`
            display: flex;
            align-items: center;
            gap: 4px 8px;
            justify-content: flex-end;
            flex-wrap: wrap;
        `
    }
);